import "./URLButton.css"

function URLButton(props) {
    return (
        <a className="btn" href={props.url} target="_blank" rel="noopener noreferrer">{props.txt}</a>
    );
}

export default URLButton;